'use strict';
angular.module('bringgApp.directives').directive('cxMenu', function () {
	return {
		templateUrl: 'scripts/directives/customer-experience/menu-directive.html',
		replace: true,
		restrict: 'E',
		scope: {
			color: '@'
		}
	};
});
